if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');
      this.submitButton = document.querySelector('#atc-button');
      this.variantImages = this.querySelectorAll('.js-variant-image');
      this.data = this.getProductData();
    
      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }

      this.submitButton.addEventListener('click', () => {
        // Trigger the submit event on the form
        this.productForm.dispatchEvent(new Event('submit'));
      });

      document.addEventListener('on:variant:change', this.onVariantChange.bind(this));

      if (this.dataset.currentVariantId) {
          this.setVisibleVariantImage(this.dataset.currentVariantId);
        }

    }

   
    

    setVisibleVariantImage(variantId) {
      this.variantImages.forEach((variantImage) => {
        variantImage.hidden = variantImage.dataset.variantId.toString() !== variantId.toString();
      });
    }

    updatePrice(variant) {
      
      this.price = this.price || document.querySelector('.atc-product-info__price > .price');
      if (!this.price) return;

      if (variant) {
        const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was');
        const unitPriceEl = this.price.querySelector('.unit-price');
        
        // Update current price and original price if on sale.
        priceCurrentEl.textContent = this.data.formatted[variant.id].price;
        
        if (priceWasEl)
          priceWasEl.textContent = this.data.formatted[variant.id].compareAtPrice || '';

        // Update unit price, if specified.
        if (variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = variant.unit_price_measurement.reference_value;
          const unit = variant.unit_price_measurement.reference_unit;

          valueEl.textContent = this.data.formatted[variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
        }

        unitPriceEl.hidden = !variant.unit_price_measurement;
        this.price.classList.toggle(
          'price--on-sale',
          variant.compare_at_price > variant.price
        );
        this.price.classList.toggle('price--sold-out', !variant.available);
      }

      this.price.querySelector('.price__default').hidden = !variant;
      this.price.querySelector('.price__no-variant').hidden = variant;
    }

    updateAddToCartButton(variant) {
      if (!variant) return;

      if (variant.available) {
        this.submitButton.textContent = "Add to Cart";
      } else {
        this.submitButton.textContent = "Sold out";
      }

      this.submitButton.disabled = !variant.available;
    }

    onVariantChange(evt) {
      
      if (evt.detail.variant) {
        this.setVisibleVariantImage(evt.detail.variant.id);

        this.updatePrice(evt.detail.variant);
        this.updateAddToCartButton(evt.detail.variant);
      }
    }

    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}


const button = document.getElementById("variantButton");
const list = document.getElementById("variantList");
const selectedText = document.getElementById("selectedVariant");

button.addEventListener("click", () => {
  list.classList.toggle("hidden");
});

document.querySelectorAll("#variantList li").forEach(item => {
  item.addEventListener("click", () => {
    const imgSrc = item.querySelector("img").src;
    const variantTitle = item.dataset.value;

    selectedText.innerHTML = "";

    const newImg = document.createElement("img");
    newImg.src = imgSrc;
    newImg.width = 24;
    newImg.height = "auto";

    selectedText.appendChild(newImg);
    selectedText.appendChild(document.createTextNode(" " + variantTitle));

    // selectedText.textContent = item.dataset.value;
    list.classList.add("hidden");
  });
});

// Close dropdown when clicking outside
document.addEventListener("click", (e) => {
  if (!button.contains(e.target) && !list.contains(e.target)) {
    list.classList.add("hidden");
  }
});
